import { GitPush400ErrorPayload } from '../../models/dbt.model';

export function build400ErrorMessage(payload: GitPush400ErrorPayload): string {
  return Object.values(payload).reduce((accCommits, commit) => {
    const errors = commit.errors.reduce((accErrors, error) => `${accErrors}${error}\n`, '');
    const commitMessage = `${commit.commit_hash}:\n\n${errors}`;
    return `${accCommits}${commitMessage}`;
  }, 'Failed to push commits\n\n');
}
